export default __webpack_public_path__ + "static/media/mobile-clock-wallpaper.41ee3274.jpg";